var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "展示名称", prop: "show_name" } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "请输入展示名称(用于后台)"
                },
                model: {
                  value: _vm.form.show_name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "show_name", $$v)
                  },
                  expression: "form.show_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "游戏", prop: "appid" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "" },
                  on: { change: _vm.gameChange },
                  model: {
                    value: _vm.form.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "appid", $$v)
                    },
                    expression: "form.appid"
                  }
                },
                _vm._l(_vm.gameLists, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.show_name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "登录回调", prop: "login_callback" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入登录回调" },
                model: {
                  value: _vm.form.login_callback,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "login_callback", $$v)
                  },
                  expression: "form.login_callback"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "支付回调", prop: "pay_callback" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入支付回调" },
                model: {
                  value: _vm.form.pay_callback,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "pay_callback", $$v)
                  },
                  expression: "form.pay_callback"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "商品检测链接", prop: "product_check_link" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入商品检测链接" },
                model: {
                  value: _vm.form.product_check_link,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "product_check_link", $$v)
                  },
                  expression: "form.product_check_link"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "state" } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                },
                _vm._l(_vm.stateList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否定时" } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "" },
                  on: { change: _vm.changTime },
                  model: {
                    value: _vm.dingshi,
                    callback: function($$v) {
                      _vm.dingshi = $$v
                    },
                    expression: "dingshi"
                  }
                },
                _vm._l(_vm.dingshiList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.dingshi == 2
            ? _c(
                "el-form-item",
                { attrs: { label: "定时时间", prop: "delay_time" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: "请选择",
                      align: "right"
                    },
                    model: {
                      value: _vm.form.delay_time,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "delay_time", $$v)
                      },
                      expression: "form.delay_time"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { staticStyle: { width: "100%", "margin-bottom": "0" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addPayTypeList()
                        }
                      }
                    },
                    [_vm._v("添加支付类型")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.form.pay_type_list, function(item, index) {
            return _c(
              "div",
              {
                key: index + "k",
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "flex-wrap": "wrap",
                  "border-bottom": "1px dashed #ccc",
                  "margin-bottom": "5px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "text-align": "right",
                      "margin-bottom": "10px"
                    }
                  },
                  [
                    _c("el-button", {
                      attrs: {
                        size: "mini",
                        type: "danger",
                        circle: "",
                        icon: "el-icon-delete"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removePayTypeList(item)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "支付类型名字",
                      prop: "pay_type_list." + index + ".pay_type_name",
                      rules: _vm.rules.pay_type_name
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "请输入支付类型名字"
                      },
                      model: {
                        value: item.pay_type_name,
                        callback: function($$v) {
                          _vm.$set(item, "pay_type_name", $$v)
                        },
                        expression: "item.pay_type_name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "支付类型",
                      prop: "pay_type_list." + index + ".pay_type",
                      rules: _vm.rules.pay_type
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入支付类型" },
                      model: {
                        value: item.pay_type,
                        callback: function($$v) {
                          _vm.$set(item, "pay_type", $$v)
                        },
                        expression: "item.pay_type"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "支付类型id",
                      prop: "pay_type_list." + index + ".pay_type_id",
                      rules: _vm.rules.pay_type_id
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "支付类型id" },
                      model: {
                        value: item.pay_type_id,
                        callback: function($$v) {
                          _vm.$set(item, "pay_type_id", $$v)
                        },
                        expression: "item.pay_type_id"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      label: "支付类型图标",
                      prop: "pay_type_list." + index + ".pay_type_icon",
                      rules: _vm.rules.pay_type_icon
                    }
                  },
                  [
                    _c("uploadImageOne", {
                      ref: "uploadImageOne",
                      refInFor: true,
                      attrs: { value: item.picfileList },
                      on: {
                        input: function($event) {
                          return _vm.payTypeImgChange($event, item, index)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "el-row",
            { staticStyle: { width: "100%", "margin-bottom": "0" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { "label-width": "0" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.addContent()
                        }
                      }
                    },
                    [_vm._v("添加参数")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.form.extend, function(domain, index) {
            return _c(
              "div",
              { key: index + "k", staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  { staticClass: "lodingItem-operationFrame  x-c" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        staticStyle: { "margin-right": "20px" },
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: domain.label,
                            callback: function($$v) {
                              _vm.$set(domain, "label", $$v)
                            },
                            expression: "domain.label"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "lodingItem",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: { clearable: "", placeholder: "请输入" },
                          model: {
                            value: domain.value,
                            callback: function($$v) {
                              _vm.$set(domain, "value", $$v)
                            },
                            expression: "domain.value"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-button", {
                      staticStyle: { margin: "0 10px 24px 10px" },
                      attrs: {
                        size: "mini",
                        type: "danger",
                        circle: "",
                        icon: "el-icon-delete"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeContent(domain)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          _vm._l(_vm.form.params, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "flex-wrap": "wrap"
                }
              },
              [
                _c("div", { staticClass: "langTitle" }, [
                  _vm._v(" " + _vm._s(item.languageName) + " ")
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "地区",
                      prop: "params." + index + ".area",
                      rules: _vm.rules.area
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入地区" },
                      model: {
                        value: item.area,
                        callback: function($$v) {
                          _vm.$set(item, "area", $$v)
                        },
                        expression: "item.area"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "地区产品名称",
                      prop: "params." + index + ".game_area_name",
                      rules: _vm.rules.game_area_name
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "请输入地区产品名称"
                      },
                      model: {
                        value: item.game_area_name,
                        callback: function($$v) {
                          _vm.$set(item, "game_area_name", $$v)
                        },
                        expression: "item.game_area_name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "地区产品描述",
                      prop: "params." + index + ".game_area_desc",
                      rules: _vm.rules.game_area_desc
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        clearable: "",
                        placeholder: "请输入地区产品描述"
                      },
                      model: {
                        value: item.game_area_desc,
                        callback: function($$v) {
                          _vm.$set(item, "game_area_desc", $$v)
                        },
                        expression: "item.game_area_desc"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "服务器名称",
                      prop: "params." + index + ".server_name",
                      rules: _vm.rules.server_name
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入标题" },
                      model: {
                        value: item.server_name,
                        callback: function($$v) {
                          _vm.$set(item, "server_name", $$v)
                        },
                        expression: "item.server_name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "页面标题",
                      prop: "params." + index + ".page_title",
                      rules: _vm.rules.page_title
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "页面标题" },
                      model: {
                        value: item.page_title,
                        callback: function($$v) {
                          _vm.$set(item, "page_title", $$v)
                        },
                        expression: "item.page_title"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      label: "背景图PC",
                      prop: "params." + index + ".banner",
                      rules: _vm.rules.banner
                    }
                  },
                  [
                    _c("uploadImageOne", {
                      ref: "uploadImageOne",
                      refInFor: true,
                      attrs: { value: item.picfileList },
                      on: {
                        input: function($event) {
                          return _vm.imgChange($event, item, index, "")
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      label: "背景图手机",
                      prop: "params." + index + ".bannerMb",
                      rules: _vm.rules.bannerMb
                    }
                  },
                  [
                    _c("uploadImageTow", {
                      ref: "uploadImageTow",
                      refInFor: true,
                      attrs: { value: item.picfileListMb },
                      on: {
                        input: function($event) {
                          return _vm.imgChange($event, item, index, "Mb")
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      label: "活动注释",
                      prop: "params." + index + ".note"
                    }
                  },
                  [
                    _c("Editor", {
                      model: {
                        value: item.note,
                        callback: function($$v) {
                          _vm.$set(item, "note", $$v)
                        },
                        expression: "item.note"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      label: "充值描述",
                      prop: "params." + index + ".recharge_desc",
                      rules: _vm.rules.recharge_desc
                    }
                  },
                  [
                    _c("Editor", {
                      model: {
                        value: item.recharge_desc,
                        callback: function($$v) {
                          _vm.$set(item, "recharge_desc", $$v)
                        },
                        expression: "item.recharge_desc"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.isOnlyWatch == "1"
            ? [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.dialogShow = _vm.fasle
                      }
                    }
                  },
                  [_vm._v("确定")]
                )
              ]
            : [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.dialogShow = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "info" },
                    on: {
                      click: function($event) {
                        return _vm.clearData(true)
                      }
                    }
                  },
                  [_vm._v("重置")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.submitData()
                      }
                    }
                  },
                  [_vm._v("提交")]
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }